import { Dialog, makeStyles, useTheme } from "@material-ui/core";
import { isJourneyVisibleState } from "pages/CustomerBooking";
import { useRecoilValue } from 'recoil';
import { requiresLocationConfirmation } from 'util/bookingStates';


const useStyles = makeStyles(theme => ({
  dialog: {
    "z-index": `${theme.zIndex.modal - 1} !important `,
  },
  dialogPaper: {
    [theme.breakpoints.down("sm")]: {
      width: '100%',
    },
    [theme.breakpoints.up("md")]: {
      width: theme.breakpoints.values.sm,
    }
  },
  dialogFullContent: {
    overflowY: 'unset'
  },
  dialogScrollContent: {

  },
  dialogRoot: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    alignContent: "center",
  },
  offsetPaper: {
    top: theme.spacing(5),
  },
  offsetScrollBody: {
    verticalAlign: 'top'
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
  },
  locationList: {
    minHeight: 200,
    overflowY: 'scroll',
    maxHeight: 200,
  },
  wrapper: {
    whiteSpace: 'normal'
  },
  cardHeaderAction: {
    margin: "auto"
  },
  cardHeaderRoot: {
    padding: theme.spacing(1),
    flexDirection: 'row',
    [theme.breakpoints.down("sm")]: {
      textAlign: 'center',
      flexDirection: 'column',
    }
  },
  addressIcon: {
    [theme.breakpoints.down("sm")]: {
      display: 'none',

    }
  },
  secondaryLocation: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  confirmedLocation: {

  },
  unconfirmedLocation: {
    color: theme.palette.text.hint,
  }
}));

const AltLocationTypeSelectDialog = ({
  booking
}) => {
  const classes = useStyles()
  const theme = useTheme()

  const isJourneyVisible = useRecoilValue(isJourneyVisibleState)
  return (
    <Dialog
      open={requiresLocationConfirmation(booking)}
      onClose={null}
      disableEnforceFocus
      maxWidth="md"
      fullWidth
      className={classes.dialog}
      scroll="paper"
      classes={{
        paper: classes.dialogRoot,
        paperScrollPaper: isJourneyVisible && classes.offsetPaper,
        paperScrollBody: isJourneyVisible && classes.offsetScrollBody,
      }}
    >
      <div>
        <h1>Location Type</h1>
      </div>
    </Dialog>
  )
}

export { AltLocationTypeSelectDialog };
